module.exports = __webpack_public_path__ + "static/media/cov_phy_dis.c89c037e.png";